module.exports = __webpack_public_path__ + "img/icomoon.542eca0.svg";